import styled from "styled-components";

export const Copy = styled.div`
  cursor: pointer;
`;
